import { useEffect } from "react";
import { ExpiracyDetail, drawBalance, privGtmKey } from "../../utils";
import { SingleProductImg } from "../CoalitionComplements";
import { not_available_horizontal } from "../../pngs";
import { CoalitionCollapsible } from "../CoalitionCollapsible";
import {
  sendTag,
  event_properties_103_03,
  event_properties_103_04,
} from "../CoalitionGtm";
import "./../CoalitionCards/CardDetail.scss";

export const CoalitionCardExtrasDetail = ({ card }) => {
  const {
    id,
    sponsor_name,
    image,
    title,
    extra_points,
    description,
    terms_and_conditions,
    valid_until,
  } = card;

  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) {
      let payload = event_properties_103_03();
      payload.extra_points_id = id;
      payload.partner = sponsor_name;
      sendTag(gtm, payload);
    }
  }, [gtm, id, sponsor_name]);
  const sendEvent = () => {
    let payload = event_properties_103_04();
    payload.extra_points_id = id;
    payload.partner = sponsor_name;
    sendTag(gtm, payload);
  };

  return (
    <div className="card-detail">
      <div className="product-image">
        <SingleProductImg load={image} error={not_available_horizontal} />
      </div>
      <div className="bullet">
        {extra_points
          ? `+ ${drawBalance(extra_points)} puntos adicionales`
          : "Te da más puntos"}
      </div>
      <div className="title">{title}</div>
      <div className="description">{description}</div>
      <ExpiracyDetail expiracy={valid_until} />
      <div
        onClick={() => sendEvent()}
        onKeyPress={() => sendEvent()}
        role="button"
        tabIndex={0}
      >
        <CoalitionCollapsible terms={terms_and_conditions} />
      </div>
    </div>
  );
};
